/**
 * @generated SignedSource<<5acf8f72ac1375ab9aff5a223e2a711e>>
 * @relayHash c856108458bf22634635bceda74a3661
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5acb48f3ca59b87c27c2f058750aca9531236d1d335bafbf39c601cb6c7affa2

import type { ConcreteRequest } from 'relay-runtime';
export type AgentVersionResolverVersionCapabilityQuery$variables = {
  cloudId: string;
};
export type AgentVersionResolverVersionCapabilityQuery$data = {
  readonly agentStudio_hasVersionCapability: {
    readonly __typename: "AgentStudioHasVersionCapability";
    readonly hasVersionCapability: boolean | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AgentVersionResolverVersionCapabilityQuery = {
  response: AgentVersionResolverVersionCapabilityQuery$data;
  variables: AgentVersionResolverVersionCapabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "LinkedField",
    "name": "agentStudio_hasVersionCapability",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasVersionCapability"
          }
        ],
        "type": "AgentStudioHasVersionCapability"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentVersionResolverVersionCapabilityQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentVersionResolverVersionCapabilityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5acb48f3ca59b87c27c2f058750aca9531236d1d335bafbf39c601cb6c7affa2",
    "metadata": {},
    "name": "AgentVersionResolverVersionCapabilityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2baa716bec911bf5b0db251fc2165a49";

export default node;
